import config from '@/app/pharmacy/shared/config/pharmacy-config.json';
import { KendoService } from '@/app/shared/services/kendo-service/kendoService.js';
import { getPaymentMethodsEnum } from '@/app/pharmacy/shared/pharmacy-enums.js'

export class DispensedHistoryCommon {

    BuildAllowedActionsDictionary(data) {
        var allowedActionsObj = [];
        for (var i = 0; i < data.length; i++) {
            allowedActionsObj[data[i].ActionName] = data[i].IsAllowed;
        }
        return allowedActionsObj;
    }
    BindODataGridParameter(url, modelID, model, sortfield, sortDir = 'desc', DDlFilterParams) {
        let pageSize = parseInt(config.pageSize);
        return new KendoService(url,
            pageSize, modelID,
            model, sortfield, true, sortDir, false, [],DDlFilterParams).data; //Must add Sort field

    }
    BindODataGrid(url, modelID, model, sortfield, sortDir = 'desc') {
        let pageSize = parseInt(config.pageSize);
        return new KendoService(url,
            pageSize, modelID,
            model, sortfield, true, sortDir).data; //Must add Sort field
    }

    MapVisitServiceSearchCriteria(obj) {

        var serializedSearchArray = this.SerializeVisitServiceSearchArrays(obj);

        var serviceUrlParameters = "?VisitId=" + obj.VisitId + "&StartCreationDate=" + obj.StartCreationDate + "&EndCreationDate=" + obj.EndCreationDate
            + "&StartPatientShare=" + obj.StartPatientShare + "&EndPatientShare=" + obj.EndPatientShare
            + "&StartInsurerShare=" + obj.StartInsurerShare + "&EndInsurerShare=" + obj.EndInsurerShare
            + "&StartTaxDue=" + obj.StartTaxDue + "&EndTaxDue=" + obj.EndTaxDue  
            + "&IsHasDiscount=" + obj.IsHasDiscount + "&PaymentStatusId=" + obj.PaymentStatusId + "&IsCancelled=" + obj.IsCancelled + "&IsServedByPharmacist=" + obj.IsServedByPharmacist +"&isByOrderMode=" + obj.isByOrderMode
            + serializedSearchArray[0] + serializedSearchArray[1] + serializedSearchArray[2] + serializedSearchArray[3] + serializedSearchArray[4] + serializedSearchArray[5] + serializedSearchArray[6] + serializedSearchArray[7];


        return serviceUrlParameters;
    }


    SerializeVisitServiceSearchArrays(obj) {
        var visitServiceClassificationIds = [];
        var ServedByIDs = [];
        var pricingStatusIds = [];
        var approvalStatusIds = [];
        var DrugIds = [];
        var BatchNo = [];
        var AuthorizationStatusIds = [];
        var serializedSearchArray = [];
        var DoneServicesIds = [];
        var i;

        //Serialize Classification
        if (obj.VisitServiceClassificationIds && obj.VisitServiceClassificationIds.length > 0) {
            for (let i = 0; i < obj.VisitServiceClassificationIds.length; i++) {
                visitServiceClassificationIds += "&VisitServiceClassificationIds[" + i + "]=" + obj.VisitServiceClassificationIds[i];
            }

            serializedSearchArray[0] = visitServiceClassificationIds;

        }
        else {
            visitServiceClassificationIds += "&VisitServiceClassificationIds[0]=" + null;
            serializedSearchArray[0] = visitServiceClassificationIds;
        }

        //Serialize pricing Status Ids
        if (obj.PricingStatusIds && obj.PricingStatusIds.length > 0) {
            for (let i = 0; i < obj.PricingStatusIds.length; i++) {
                pricingStatusIds += "&PricingStatusIds[" + i + "]=" + obj.PricingStatusIds[i];
            }

            serializedSearchArray[1] = pricingStatusIds;
          

        }
        else {
            pricingStatusIds += "&PricingStatusIds[0]=" + null;
            serializedSearchArray[1] = pricingStatusIds;
           
        }

        //Serialize Approval Status Ids
        if (obj.ApprovalStatusIds && obj.ApprovalStatusIds.length > 0) {
            for (let i = 0; i < obj.ApprovalStatusIds.length; i++) {
                approvalStatusIds += "&ApprovalStatusIds[" + i + "]=" + obj.ApprovalStatusIds[i];
            }

            serializedSearchArray[2] = approvalStatusIds;

        }
        else {
            approvalStatusIds += "&ApprovalStatusIds[0]=" + null;
            serializedSearchArray[2] = approvalStatusIds;
        }

        //Serialize Served By List
        if (obj.ServedByIDs && obj.ServedByIDs.length > 0) {
            for (let i = 0; i < obj.ServedByIDs.length; i++) {
                ServedByIDs += "&ServedByIDs[" + i + "]=" + obj.ServedByIDs[i];
            }

            serializedSearchArray[3] = ServedByIDs;

        }
        else {
            ServedByIDs += "&ServedByIDs[0]=" + null;
            serializedSearchArray[3] = ServedByIDs;
        }

        if (obj.DrugIds && obj.DrugIds.length > 0) {
            for (let i = 0; i < obj.DrugIds.length; i++) {
                DrugIds += "&DrugIds[" + i + "]=" + obj.DrugIds[i];
            }

            serializedSearchArray[4] = DrugIds;
          
        } else {
            DrugIds += "&DrugIds[0]=" + null;
            serializedSearchArray[4] = DrugIds;
           

        }


        //Serialize Btach No
        if (obj.BatchNo && obj.BatchNo.length > 0) {
            for (i = 0; i < obj.BatchNo.length; i++) {
                BatchNo += "&BatchNo[" + i + "]=" + obj.BatchNo[i];
            }

            serializedSearchArray[5] = BatchNo;

        }
        else {
            BatchNo += "&BatchNo[0]=" + null;
            serializedSearchArray[5] = BatchNo;
        }

        //Serialize Authorization status  Ids
        if (obj.AuthorizationStatusIds && obj.AuthorizationStatusIds.length > 0) {
            for (let i = 0; i < obj.AuthorizationStatusIds.length; i++) {
                AuthorizationStatusIds += "&AuthorizationStatusIds[" + i + "]=" + obj.AuthorizationStatusIds[i];
            }

            serializedSearchArray[6] = AuthorizationStatusIds;

        }
        else {
            AuthorizationStatusIds += "&AuthorizationStatusIds[0]=" + null;
            serializedSearchArray[6] = AuthorizationStatusIds;
        }

        //Serialize done service  Ids
        if (obj.DoneServicesIds && obj.DoneServicesIds.length > 0) {
            for (let i = 0; i < obj.DoneServicesIds.length; i++) {
                DoneServicesIds += "&DoneServicesIds[" + i + "]=" + obj.DoneServicesIds[i];
            }

            serializedSearchArray[7] = DoneServicesIds;

        }
        else {
            DoneServicesIds += "&DoneServicesIds[0]=" + null;
            serializedSearchArray[7] = DoneServicesIds;
        }
        console.log(serializedSearchArray);
        return serializedSearchArray;
    }

    PrepareDefaultVisitServiceSearchCriteria(visitId, IsServedByPharmacist, DoneServicesIds, isByOrderMode) {
        return {
            VisitId: visitId,
            StartCreationDate: null,
            EndCreationDate: null,
            StartPatientShare: null,
            EndPatientShare: null,
            StartInsurerShare: null,
            EndInsurerShare: null,
            StartTaxDue: null,
            EndTaxDue: null,
            IsHasDiscount: undefined,
            PaymentStatusId: null,
            IsCancelled: false,
            IsServedByPharmacist: IsServedByPharmacist,
            VisitServiceClassificationIds: null,
            PricingStatusIds: null,
            ApprovalStatusIds: null,
            ServedByIDs: null,
            DrugIds: null,
            BatchNo: null,
            AuthorizationStatusIds: null,
            DoneServicesIds: DoneServicesIds,
            isByOrderMode: isByOrderMode
        }
    }

    PrepareDefaultCanceledVisitServiceSearchCriteria(visitId, IsServedByPharmacist) {
        var defaultObj = this.PrepareDefaultVisitServiceSearchCriteria(visitId, IsServedByPharmacist);
        defaultObj.IsCancelled = true;

        return defaultObj;
    }

    SetPaymentMethodsPermissions(paymentMethods) {
        for (var i = 0; i < paymentMethods.length; i++) {
            switch (paymentMethods[i].ID) {
                case parseInt(getPaymentMethodsEnum().Cash):
                    paymentMethods[i].Permission = 'PharmacyAddPayment';
                    break;
                case parseInt(getPaymentMethodsEnum().CreditCard):
                    paymentMethods[i].Permission = 'PharmacyAddCreditPayment';
                    break;
                case parseInt(getPaymentMethodsEnum().DirectDebit):
                    paymentMethods[i].Permission = 'PharmacyAddDebitPayment';
                    break;
                case parseInt(getPaymentMethodsEnum().SelfPaid):
                    paymentMethods[i].Permission = 'PharmacyAddSelfPaidPayment';
                    break;

            }
        }

        return paymentMethods;
    }

    SetPaymentMethodRefundPermissions(paymentMethods) {

        for (var i = 0; i < paymentMethods.length; i++) {
            switch (paymentMethods[i].PaymentMethodID) {
                case parseInt(getPaymentMethodsEnum().Cash):
                    paymentMethods[i].Permission = 'PharmacyRefundCash';
                    break;
                case parseInt(getPaymentMethodsEnum().CreditCard):
                    paymentMethods[i].Permission = 'PharmacyRefundCredit';
                    break;
                case parseInt(getPaymentMethodsEnum().DirectDebit):
                case parseInt(getPaymentMethodsEnum().SelfPaid):
                    paymentMethods[i].Permission = 'PharmacyRefundDebit';
                    break;
            }
        }

        return paymentMethods;
    }
}

const dispensedHistoryCommon = new DispensedHistoryCommon();

export { dispensedHistoryCommon };